<template>
  <div class="kds-wrapper d-flex flex-column bg-dark">
    <!-- Top Navbar + pull-tab -->
    <div class="kds-header-wrap flex-shrink-0">
      <nav
        v-show="!headerCollapsed"
        class="navbar kds-navbar flex-nowrap px-3 py-2"
      >
        <div class="d-flex align-items-center gap-2 min-w-0">
          <h6 class="mb-0 fw-bold text-white text-nowrap">
            <i class="fa-solid fa-kitchen-set text-warning"></i>
            <span class="d-none d-md-inline ms-2">{{ $t('KDS Mode') }}</span>
            <span class="d-none d-md-inline text-secondary fw-normal small">· {{ $appName }}</span>
          </h6>
          <span class="badge bg-secondary text-white text-truncate">{{ kdsName }}</span>
          <span
            v-if="stationName"
            class="badge text-white text-truncate"
            :style="{ backgroundColor: stationColor || '#2563eb' }"
          >
            <i class="fa-solid fa-fire-burner me-1"></i>{{ stationName }}
          </span>
        </div>

        <div class="d-flex align-items-center gap-2 flex-shrink-0">
          <span class="text-secondary small d-none d-md-inline text-nowrap">
            <i class="fa-solid fa-circle-user me-1"></i>{{ userName }}
          </span>
          <button
            class="btn btn-outline-danger btn-sm fw-bold text-nowrap"
            @click="handleExitKDS"
          >
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
            <span class="d-none d-sm-inline ms-1">{{ $t('Exit KDS') }}</span>
          </button>
        </div>
      </nav>

      <!-- Pull-tab on the bottom edge — toggles the bar (sits over the empty centre of bar 2) -->
      <button
        class="kds-pull-tab"
        :title="headerCollapsed ? $t('Show menu') : $t('Hide menu')"
        @click="headerCollapsed = !headerCollapsed"
      >
        <i class="fa-solid" :class="headerCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </button>
    </div>

    <license-banner class="mx-3 mt-2 flex-shrink-0" />

    <!-- Content -->
    <main class="flex-grow-1 overflow-hidden">
      <!-- แพ็กไม่มีจอครัว (ทุกแพ็กตอนนี้มี — กันไว้เผื่อแพ็กในอนาคต / แพ็กเปลี่ยนกลางคัน) -->
      <feature-not-available v-if="$route.meta.feature && !$hasFeature($route.meta.feature)" />
      <router-view v-else />
    </main>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { useKDSStore }  from '@/stores/kds.store';
import { useAuthStore } from '@/stores/auth.store';
import { socketService } from '@/services/socket.service';
import { initNotifySound } from '@/composables/useNotifySound';
import LicenseBanner from '@/components/license/LicenseBanner.vue';
import FeatureNotAvailable from '@/plugins/FeatureNotAvailable.vue';

export default {
  name: 'KDSLayout',
  components: { LicenseBanner, FeatureNotAvailable },
  setup() {
    const socketConnected = ref(socketService.isConnected());

    // Unlock the shared notification sound on the first gesture in the KDS shell.
    onMounted(() => initNotifySound());

    // connected = true, ทุก state อื่น (connecting, disconnected, unavailable) = false
    const offChange = socketService.onConnectionChange((isUp) => {
      socketConnected.value = isUp;
    });

    onUnmounted(() => offChange());

    return { socketConnected };
  },
  data() {
    return {
      headerCollapsed: false,   // manual collapse of the top identity bar only
    };
  },
  computed: {
    kdsName() { return useKDSStore().name; },
    stationName() { return useKDSStore().stationName; },
    stationColor() { return useKDSStore().stationColor; },
    userName() {
      const user = useAuthStore().user;
      return user?.fullname || 'Guest';
    }
  },
  methods: {
    handleExitKDS() {
      try {
        let self = this;
        this.$swal({
          icon: 'question',
          iconColor: '#FF7043',
          title: this.$t('Exit KDS Mode') + '?',
          html: this.$t('Return to the Back Office dashboard.'),
          showCancelButton: true,
          cancelButtonText: this.$t('Cancel'),
          confirmButtonText: '<i class="fa-solid fa-arrow-right-from-bracket me-1"></i>' + this.$t('Exit KDS'),
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger me-2',
          },
          focusConfirm: false,
          reverseButtons: true,
          preConfirm: async function () {
            useKDSStore().outShop();
            self.$router.push({ name: 'kds-register' });
          },
        });
      } catch (error) {
      }
    }
  }
}
</script>

